import React from "react";
import { Modal } from "react-bootstrap";
import succesimage from "assets/images/Succes_img.png";
import './SuccessPopup.css';

interface SuccessPopupProps {
  show: boolean;
  onClose: () => void;
  title?: string;
  message?: string;
  buttonText?: string;
}

/**
 * Project-wide success popup — same look as the one used in ProjectDetailsView.
 * Uses Succes_img.png illustration with a centered title, message, and close button.
 */
const SuccessPopup: React.FC<SuccessPopupProps> = ({
  show,
  onClose,
  title = "Success!",
  message = "The action was completed successfully.",
  buttonText = "Close",
}) => {
  return (
    <Modal
      show={show}
      onHide={onClose}
      centered
      backdrop="static"
      dialogClassName="custom-modal"
    >
      {/* Close button */}
      <button
        onClick={onClose}
        aria-label="Close"
        style={{
          position: "absolute",
          top: 14,
          right: 14,
          width: 36,
          height: 36,
          borderRadius: "50%",
          border: "none",
          background: "#f3f4f6",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          cursor: "pointer",
          zIndex: 10,
          fontSize: 18,
          color: "#6b7280",
          lineHeight: 1,
        }}
      >
        ×
      </button>

      <Modal.Body className="text-center px-4 pb-4 pt-4">
        {/* Success illustration */}
        <div style={{ marginBottom: 20 }}>
          <img
            src={succesimage}
            alt="success"
            style={{ width: 140, maxWidth: "60%", height: "auto" }}
          />
        </div>

        {/* Title */}
        <h4
          style={{
            fontWeight: 700,
            fontSize: "1.25rem",
            color: "#111827",
            marginBottom: 10,
          }}
        >
          {title}
        </h4>

        {/* Message */}
        <p
          style={{
            color: "#6b7280",
            fontSize: "0.9rem",
            lineHeight: 1.6,
            maxWidth: 360,
            margin: "0 auto 28px",
          }}
        >
          {message}
        </p>

        {/* Primary button */}
        <button
          onClick={onClose}
          style={{
            minWidth: 140,
            height: 44,
            borderRadius: 12,
            border: "none",
            background: "#0b2e83",
            color: "#ffffff",
            fontWeight: 600,
            fontSize: "0.95rem",
            cursor: "pointer",
            transition: "background 0.18s ease",
            padding: "0 24px",
          }}
          onMouseEnter={(e) => {
            (e.currentTarget as HTMLButtonElement).style.background = "#09246a";
          }}
          onMouseLeave={(e) => {
            (e.currentTarget as HTMLButtonElement).style.background = "#0b2e83";
          }}
        >
          {buttonText}
        </button>
      </Modal.Body>
    </Modal>
  );
};

export default SuccessPopup;
